import { parametersSlice } from "./parametersSlice";
import * as actions from "./parametersActions";
import * as selectors from "./parametersSelectors";

export { actions };
export { selectors };
export default parametersSlice.reducer;
